export const gradientsLight = {
  loading: {
    start: 0,
    end: 100,
    angle: 90,
    colors: ['transparent', 'grey/dark/background', 'transparent'],
    kind: 'linear',
  },
  primary: {
    start: 0,
    end: 100,
    angle: 130,
    colors: ['gradient/start', 'gradient/middle', 'gradient/end'],
    kind: 'linear',
  },
  secondary: {
    start: 0,
    end: 100,
    angle: 130,
    colors: ['gradient/start', 'gradient/middle', 'gradient/start'],
    kind: 'linear',
  },
  blue: {
    start: -20,
    end: 100,
    angle: 161,
    colors: ['gradient/blue', 'gradient/middle', 'primary'],
    kind: 'linear',
  },
};
